/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.Memberships {
    "use strict";

    export class NotesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Membership> {

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template, params.isPrimarySection, params.handlesOwnCrud,
                params.baseEndpoint, params.sectionEndpoint,
                params.loggingService, params.dataService, params.identityService, params.noun,null,params.sectionSecurityKey);
        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = <Model.Membership>data;
            });
        }

        activate(): void {
            // Initialize model properties
            super.activate();
        }

        
    }
}